<h5 class="header">SMS Credit Subscription</h5>

<ng-container *ngIf="emptySubscription$ | async; else withSubscription">
  <div class="ordering">
    <ng-container *ngFor="let formConfig of orderingEmptyFormFields">
      <div class="ordering__row" [formGroup]="formConfig.group">
        <div class="ordering__forms">
          <ng-container
            *ngTemplateOutlet="
              templateOrderingFormRow;
              context: {
                formConfig: formConfig,
                class: 'ordering__forms__field'
              }
            "
          ></ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #withSubscription>
  <div class="credits-information-panel">
    <div class="credits-information-panel__row">
      <ng-container *ngIf="current$ | async as current">
        <span>
          <b>{{ current.totalCredits | credits }}</b> remaining credits on the
          account = <b>{{ current.subscriptionCredits | credits }}</b> from
          <b>{{ current.totalSubscriptionCredits | credits }}</b>
          subscription +
          <b>{{ current.topUpCredits | credits }}</b> from top-ups
        </span>
        <ng-container *ngIf="(upcomingSubscription$ | async)?.blocked">
          <ng-container
            *ngTemplateOutlet="
              currentCreditTemplateValidation;
              context: { totalCredits: current.totalCredits }
            "
          ></ng-container>
        </ng-container>
      </ng-container>
    </div>
    <div class="credits-information-panel__row">
      <span class="credits-information-panel__row__title"
        ><b>Upcoming subscription changes</b></span
      >
      <div class="credits-information-panel__row__items">
        <div class="credits-information-panel__row__items__item">
          <ng-container
            *ngIf="
              subscriptionChange$ | async as subscriptionChange;
              else noChanges
            "
          >
            <ng-container *ngIf="credits$ | async as credits">
              <span
                class="label"
                *ngIf="
                  (subscriptionChange?.effectiveDate | dateToSeconds) <
                    (credits.upcoming.effectiveDate | dateToSeconds);
                  else other
                "
              >
                - on <b>{{ subscriptionChange?.effectiveDate }}</b> remaining
                credits change to
                <b>{{ credits.remainingCredits | credits }}</b> (<b>{{
                  credits.upcoming.credits | credits
                }}</b>
                new subscription -
                <b>{{ credits.current.totalSubscriptionCredits | credits }}</b>
                current subscription +
                <b>{{ credits.current.totalCredits | credits }}</b>
                currently remaining)
              </span>
              <ng-template #other>
                <span class="label">
                  - on <b>{{ subscriptionChange?.effectiveDate }}</b> remaining
                  credits change to
                  <b>{{
                    subscriptionChange?.credits + (activeTopupCredits$ | async)
                      | credits
                  }}</b>
                  (new subscription change -
                  <b>{{ subscriptionChange?.credits | credits }}</b>
                  <ng-container
                    *ngIf="activeTopupCredits$ | async as activeTopupCredits"
                  >
                    <b *ngIf="activeTopupCredits > 0">
                      + {{ activeTopupCredits | credits }} topups</b
                    >
                  </ng-container>
                  )
                </span>
              </ng-template>
            </ng-container>
            <span
              class="credits-information-panel__row__items__item__btn btn-danger btn-sm"
              (click)="removeUpcomingSubscription(subscriptionChange.id)"
              aria-label="Remove subscription"
            >
              <i class="fas fa-trash"></i>
            </span>
          </ng-container>
          <ng-template #noChanges>
            <span class="label">- no subscription credit changes</span>
          </ng-template>
        </div>
        <div
          *ngIf="upcomingSubscription$ | async as upcomingSubscription"
          class="credits-information-panel__row__items__item"
        >
          <span class="label"
            >- on <b>{{ upcomingSubscription?.effectiveDate }}</b> subscription
            credits automatically renew to
            <b>{{ upcomingSubscription?.credits }}</b></span
          >
        </div>
      </div>
    </div>
    <div class="credits-information-panel__row">
      <span class="credits-information-panel__row__title"
        ><b>Active and upcoming credits top-ups</b></span
      >
      <ng-container *ngIf="topUps$ | async as topUps">
        <div
          *ngIf="topUps?.length > 0; else noTopUps"
          class="credits-information-panel__row__items"
        >
          <div
            *ngFor="let topUp of topUps; trackBy: trackById"
            class="credits-information-panel__row__items__item"
          >
            <span>
              <b>{{ topUp.credits | credits }}</b> top-up credits effective on
              <b>{{ topUp.effectiveDate }}</b> and expire on
              <b>{{ topUp.expiryDate }}</b>
            </span>
            <span
              *ngIf="topUp.canDelete"
              class="credits-information-panel__row__items__item__btn btn-danger btn-sm"
              (click)="removeUpcomingTopUp(topUp.id)"
              aria-label="Remove top-up"
            >
              <i class="fas fa-trash"></i>
            </span>
          </div>
        </div>
        <ng-template #noTopUps>- no top ups</ng-template>
      </ng-container>
    </div>
  </div>
  <div class="ordering">
    <ng-container *ngFor="let formConfig of orderingFormsFields">
      <div
        class="ordering__row"
        [formGroup]="formConfig.group"
        [ngClass]="
          (formConfig.disabled$ | async) ? 'ordering__row--disabled' : ''
        "
      >
        <div class="ordering__forms">
          <ng-container
            *ngTemplateOutlet="
              templateOrderingFormRow;
              context: {
                formConfig: formConfig,
                class: 'ordering__forms__field'
              }
            "
          ></ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template
  #templateOrderingFormRow
  let-formConfig="formConfig"
  let-class="class"
>
  <div *ngFor="let field of formConfig.fields" [ngClass]="[class]">
    <ng-container
      *ngTemplateOutlet="
        templateFormField;
        context: {
          field: field,
          messages: formConfig.messages
        }
      "
    ></ng-container>
  </div>
  <div class="button"></div>
  <div class="action">
    <app-button
      [disabled]="
        formConfig.group.invalid ||
        (formConfig.loading$ | async) ||
        (formConfig.disabled$ | async)
      "
      bsClass="primary"
      [labeled]="true"
      (click)="formConfig.action()"
      [attr.aria-label]="formConfig.buttonLabel"
    >
      <ng-container *ngIf="!(formConfig.loading$ | async); else loading">{{
        formConfig.buttonLabel
      }}</ng-container>
      <ng-template #loading
        ><app-loading-spinner size="small"></app-loading-spinner
      ></ng-template>
    </app-button>
  </div>
</ng-template>

<ng-template #templateFormField let-field="field" let-messages="messages">
  <ng-container
    *ngTemplateOutlet="
      templateForm;
      context: {
        field: field
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      templateValidation;
      context: {
        formControl: field.formControl,
        messages: messages
      }
    "
  ></ng-container>
</ng-template>

<ng-template #templateForm let-field="field">
  <ng-container
    *ngTemplateOutlet="
      creditForm;
      context: {
        description: field.description,
        formControl: field.formControl,
        type: field.type
      }
    "
  ></ng-container>
</ng-template>

<ng-template
  #creditForm
  let-description="description"
  let-formControl="formControl"
  let-type="type"
>
  <div class="credit-form">
    <label
      for="credits"
      class="credit-form--description"
      [attr.aria-label]="description"
    >
      {{ description }}
    </label>
    <div
      class="form-control credit-form--date"
      *ngIf="type === 'date'; else default"
    >
      <input
        [formControl]="formControl"
        ngbDatepicker
        #d="ngbDatepicker"
        placeholder="yyyy/mm/dd"
      />
      <i class="fas fa-calendar" (click)="d.toggle()"></i>
    </div>
    <ng-template #default>
      <input
        name="credits"
        class="form-control credit-form--value"
        type="text"
        maxLength="17"
        [formControl]="formControl"
      />
    </ng-template>
  </div>
</ng-template>

<ng-template #currentCreditTemplateValidation let-totalCredits="totalCredits">
  <div class="current-credit-validation">
    <span
      >Credit quota exceeded by <b>{{ totalCredits }}</b> credits. Automatic
      credits renewal is disabled. When the customer has paid the negative
      balance, hit Reset button to remove the negative balance from the record
      and re-enable the automatic credit renewal</span
    >
    <button class="button btn btn-danger" (click)="resetCredits()">
      Reset
    </button>
  </div>
</ng-template>

<ng-template
  #templateValidation
  let-formControl="formControl"
  let-messages="messages"
>
  <div
    *ngIf="formControl.invalid && (formControl.dirty || formControl.touched)"
    class="credit-form-validation"
  >
    <span *ngIf="formControl.hasError('required')">
      {{ messages?.required || 'Required field' }}
    </span>
    <span *ngIf="formControl.hasError('pattern')">
      {{ messages?.pattern || 'Invalid pattern' }}
    </span>
    <span
      *ngIf="
        formControl.hasError('wrongDate') || formControl.hasError('ngbDate')
      "
    >
      {{ messages?.wrongDate || 'Wrong date' }}
    </span>
    <span *ngIf="formControl.hasError('wrongOrderNumber')">
      {{ messages?.wrongOrderNumber || 'Wrong order number' }}
    </span>
    <span *ngIf="formControl.hasError('wrongSubscriptionCredits')">
      {{ messages?.wrongSubscriptionCredits || 'Wrong value' }}
    </span>
    <span *ngIf="formControl.hasError('wrongTopUpCredits')">
      {{ messages?.wrongTopUpCredits || 'Wrong value' }}
    </span>
    <span *ngIf="formControl.hasError('wrongTopUpEffectiveDate')">
      {{ messages?.wrongTopUpEffectiveDate || 'Wrong date' }}"
    </span>
    <span *ngIf="formControl.hasError('wrongTopUpExpirationDate')">
      {{ messages?.wrongTopUpExpirationDate || 'Wrong date' }}"
    </span>
  </div>
</ng-template>
